




























































































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Button from '@/components/common/elements/Button.vue';
import Table from '@/components/common/elements/Table.vue';
import SingleText from '@/components/common/elements/SingleText.vue';
import DialogMasterSelectMultiControlTable from '@/components/common/modules/DialogMasterSelectMultiControlTable.vue';
import AutoCreateForm from '@/components/form/AutoCreateForm.vue';

@Component({
  components: {
    Button,
    Table,
    SingleText,
    DialogMasterSelectMultiControlTable,
    AutoCreateForm
  }
})
/* eslint-disable @typescript-eslint/camelcase */
export default class AdvanceCreditInformationTab extends Vue {
  inheritAttrs = false;

  @Prop({ default: () => ({}) })
  private item: any;
  // ダイアログのエリア外を押下した際にBOXを閉じるか
  @Prop({ default: true })
  private isPersistent?: boolean;

  // マスタ参照ダイアログの開閉ステータス
  private masterSelectDialogStatus = false;
  // マスタ参照ダイアログを開く前に選択した項目情報を控える
  private responseCopy: any = {};

  // 事前与信テーブル内入力イベント通知
  @Emit('tabChildrenEventRelay')
  private getdataRelay(response: any) {
    response.action = 'creditTab';
    response.eventName = 'inputTableData';
    return response;
  }

  // 事前与信テーブル項目追加ボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private clickItemAdditionButtonRelay(response: any) {
    return { action: 'creditTab', eventName: 'clickItemAdditionButton' };
  }

  // 事前与信テーブル内ボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private clickButton(response: any) {
    response.action = 'creditTab';
    response.eventName = 'clickTableButton';
    switch (response.buttonName) {
      case 'selectButtonIndex': {
        // 検索ボタン（マスタ参照）
        // ダイアログを開く前に選択した項目情報を控える
        this.responseCopy = response;
        this.masterSelectDialogStatus = true;
        break;
      }
      case 'deleteButton': {
        // 削除ボタン
        return response;
      }
      case 'applyButton': {
        // 申込情報ボタン
        return response;
      }
    }
  }

  // マスタ参照ダイアログ選択イベント通知
  @Emit('tabChildrenEventRelay')
  private catchTableDataRelay(response: any) {
    this.masterSelectDialogStatus = false;
    // マスタ選択ダイアログで選択された情報を返却
    return {
      action: 'creditTab',
      eventName: 'clickTableButton',
      buttonName: 'selectButtonIndex',
      selectData: response.selectData,
      selectRowData: this.responseCopy
    };
  }

  // 申込情報ダイアログ内入力イベント通知
  @Emit('tabChildrenEventRelay')
  private catchDialogInput(response: any) {
    response.action = 'creditTab';
    response.eventName = 'catchDialogInput';
    return response;
  }

  // 申込情報ダイアログ設定ボタンイベント通知
  @Emit('tabChildrenEventRelay')
  private applyDialogEntry() {
    const responseData: any = {};
    responseData.action = 'creditTab';
    responseData.eventName = 'applyDialogEntry';
    return responseData;
  }

  // 申込情報ダイアログキャンセルボタン
  @Emit('tabChildrenEventRelay')
  private applyDialogClose() {
    const responseData: any = {};
    responseData.action = 'creditTab';
    responseData.eventName = 'applyDialogClose';
    return responseData;
  }
}
